module.exports = __webpack_public_path__ + "img/item_bg.bd24e3a.png";